import Image from 'next/image';
import { AUTOPILOT_LINK, BLOG_LINK, CLIENT_COMMUNICATION_LINK, COMPASS_LINK, COPILOT_LINK, CUSTOMER_SERVICE_LINK, CUSTOMER_STORIES_LINK, DOWNLOAD_APP_LINK, EMAIL_MANAGEMENT_LINK, EXTERNAL_AGENT_LINK, FRONT_AI_OVERVIEW_LINK, FRONT_OVERVIEW_LINK, HELP_DESK_LINK, INTEGRATIONS_API_LINK, INTEGRATIONS_LINK, KNOWLEDGE_BASE_LINK, RESOLVE_LINK, PRICING_LINK, PRODUCT_UPDATES_LINK, SHARED_INBOX_LINK, SMART_CSAT_LINK, SMART_QA_LINK, TICKETING_LINK } from './navigation-links';

const FOOTER_PROPS = {
  tagline: 'The AI customer operations platform.',
  badgeIcons: [
    <Image key="badge-1" width={83} height={107} src="https://front.com/assets/award-badges/g2-summer-2026-enterprise-best-support.svg" className="block" alt="g2-badge-quality-of-support-enterprise-winter-2026" />,
    <Image key="badge-2" width={83} height={107} src="https://front.com/assets/award-badges/g2-summer-2026-enterprise-leader.svg" className="block" alt="g2-badge-leader-enterprise-winter-2026" />,
    <Image key="badge-3" width={83} height={107} src="https://front.com/assets/award-badges/g2-summer-2026-mid-market-best-results.svg" className="block" alt="g2-badge-best-results-midmarket-winter-2026" />,
  ],

  socialLinks: [
    {
      title: 'Linked In',
      href: 'https://www.linkedin.com/company/fronthq',
      icon: <Image width={27} height={27} src="https://front.com/webassets/rebrand/icon-social-linkedin.svg" className="block" alt="Linked In" />,
    },
    {
      title: 'Facebook',
      href: 'https://www.facebook.com/FrontHQ',
      icon: <Image width={27} height={27} src="https://front.com/webassets/rebrand/icon-social-facebook.svg" className="block" alt="Facebook" />,
    },
    {
      title: 'Instagram',
      href: 'https://www.instagram.com/FrontHQ/',
      icon: <Image width={27} height={27} src="https://front.com/webassets/rebrand/icon-social-instagram.svg" className="block" alt="Instagram" />,
    },
  ],

  linkColumns: [
    {
      sections: [
        {
          title: 'AI Platform',
          links: [
            { title: FRONT_AI_OVERVIEW_LINK.title, href: FRONT_AI_OVERVIEW_LINK.href },
            { title: AUTOPILOT_LINK.title, href: AUTOPILOT_LINK.href },
            { title: COPILOT_LINK.title, href: COPILOT_LINK.href },
            { title: EXTERNAL_AGENT_LINK.title, href: EXTERNAL_AGENT_LINK.href },
            { title: COMPASS_LINK.title, href: COMPASS_LINK.href },
            { title: SMART_QA_LINK.title, href: SMART_QA_LINK.href },
            { title: SMART_CSAT_LINK.title, href: SMART_CSAT_LINK.href },
          ],
        },
        {
          title: 'Use Cases',
          links: [
            { ...CUSTOMER_SERVICE_LINK },
            { ...EMAIL_MANAGEMENT_LINK },
            { ...CLIENT_COMMUNICATION_LINK },
          ],
        },
        {
          title: 'Compare',
          links: [
            { title: 'Front vs. Zendesk', href: '/compare/front-vs-zendesk' },
            { title: 'Front vs. Freshdesk', href: '/compare/front-vs-freshdesk' },
            { title: 'Front vs. Intercom', href: '/compare/front-vs-intercom' },
            { title: 'Front vs. Help Scout', href: '/compare/front-vs-help-scout' },
            { title: 'Front vs. Salesforce', href: '/compare/front-vs-sfdc' },
            { title: 'Front vs. Hiver', href: '/compare/front-vs-hiver' },
            { title: 'Front vs. Missive', href: '/compare/front-vs-missive' },
            { title: 'Front vs. Pylon', href: '/compare/front-vs-pylon' },
          ],
        },
        {
          title: 'Company',
          links: [
            { title: 'About', href: '/about' },
            { title: 'Careers', href: '/jobs' },
            { title: 'Press Kit', href: '/about#front-media-assets' },
            { title: 'Real-Time Metrics', href: '/support-report' },
            { title: 'Become a Partner', href: '/partners/integration' },
            { title: 'Customer Referral', href: '/customer-referral' },
            { title: 'Contact Support', href: 'https://help.front.com/en/contact-us' },
            { title: 'Legal', href: '/legal' },
          ],
        },
        {
          title: 'More Features',
          links: [
            { title: FRONT_OVERVIEW_LINK.title, href: FRONT_OVERVIEW_LINK.href },
            { title: HELP_DESK_LINK.title, href: HELP_DESK_LINK.href },
            { title: SHARED_INBOX_LINK.title, href: SHARED_INBOX_LINK.href },
            { title: TICKETING_LINK.title, href: TICKETING_LINK.href },
            { title: KNOWLEDGE_BASE_LINK.title, href: KNOWLEDGE_BASE_LINK.href },
            { title: RESOLVE_LINK.title, href: RESOLVE_LINK.href },
            { title: INTEGRATIONS_API_LINK.title, href: INTEGRATIONS_API_LINK.href },
          ],
        },
        {
          title: 'Explore',
          links: [
            { ...PRICING_LINK },
            { ...PRODUCT_UPDATES_LINK },
            { ...DOWNLOAD_APP_LINK },
          ],
        },

        {
          title: 'Resources',
          links: [
            { ...BLOG_LINK },
            { ...CUSTOMER_STORIES_LINK },
            { title: "The Coordination Tax", href: 'https://research.front.com' },
            { title: 'Help', href: 'https://help.front.com/' },
            { title: 'Academy', href: 'https://academy.front.com/app' },
            { title: 'Developers', href: 'https://dev.frontapp.com/docs/welcome' },
            { title: INTEGRATIONS_LINK.title, href: INTEGRATIONS_LINK.href },
            { title: 'Glossary', href: '/glossary' },
          ],
        },

        /*
         *{
         *  title: 'Features',
         *  links: [
         *    { title: 'Team email collaboration', href: '/product/collaboration' },
         *    { title: 'AI & Automation', href: '/product/ai' },
         *    { title: 'Omnichannel', href: '/product/analytics' },
         *    { title: 'Support Report', href: '/product/support-report' },
         *  ],
         *},
         */
      ],
      /*
       *featuredLinks: [
       *  { title: 'Download App', href: '/download' },
       *  { title: 'Pricing', href: '/pricing' },
       *],
       */
    },



  ],

  smallLinksTitle: 'Additional Resources',
  smallLinkColumns: [
    {
      title: 'Customer Support and Service',
      links: [
        { title: 'The State of Service Expectations', href: '/resources/state-of-service-expectations' },
        {
          title: 'Customer Support Metrics Library',
          href: '/guides/top-customer-service-metrics',
        },
        { title: 'Guide to 100% CSAT', href: '/blog/improve-csat' },
      ],
    },
    {
      title: 'AI and Automation',
      links: [
        { title: 'Boost Agent Support Productivity', href: '/blog/customer-service-automation-ai' },
        { title: 'Front\'s New AI Capabilities', href: '/blog/customer-service-agent-assistance-ai' },
        {
          title: 'AI vs. Human Support Strategy',
          href: '/resources/ai-vs-human-why-you-dont-have-to-choose',
        },
      ],
    },
    {
      title: 'Knowledge Base',
      links: [
        { title: '5 Best Practices for Self-Service Support', href: '/resources/how-to-scale-delightful-customer-experiences-with-self-service-support' },
        { title: 'Create AI-Friendly Help Center Articles', href: '/resources/creating-ai-friendly-help-center-articles' },
        { title: 'Top Tips for Knowledge Base Articles', href: '/blog/how-to-write-knowledge-base-articles' },
      ],
    },
    {
      title: 'More',
      links: [
        { title: 'Support Message Templates', href: '/resources/5-tried-and-true-message-templates-to-improve-your-support-teams-csat' },
        { title: 'Shared Inbox Management Tips', href: '/guides/shared-inbox-management' },
        { title: 'Front Reviews', href: '/reviews' },
        { title: 'Front AI Information', href: '/guides/ai-information' },
      ],
    },
  ],
  legalLinks: [
    { title: 'SaaS Service Agreement', href: '/legal/saas-services-agreement' },
    { title: 'Privacy Notice', href: '/legal/privacy-notice' },
    { title: 'Cookie Policy', href: '/legal/cookie-policy' },
    {
      title: 'Google User Data Privacy Notice',
      href: '/legal/front-products-and-services-privacy-notice#google_user_data_privacy_notice',
    },
    { title: 'Status', href: 'https://www.frontstatus.com/' },
  ],
  copyright: '2026 FrontApp, Inc. All Rights Reserved.',
};

export default FOOTER_PROPS;
